import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { MOCKUP_URL, recentBuyers } from '../data/content';
const FIRST_DELAY = 6000;
const SHOW_FOR = 5000;
const INTERVAL = 14000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [minutes, setMinutes] = useState(2);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const show = () => {
      setIndex(Math.floor(Math.random() * recentBuyers.length));
      setMinutes(1 + Math.floor(Math.random() * 14));
      setVisible(true);
      hideTimer = window.setTimeout(() => setVisible(false), SHOW_FOR);
    };
    const first = window.setTimeout(show, FIRST_DELAY);
    const loop = window.setInterval(show, INTERVAL);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <AnimatePresence data-id="element-40" data-mp="1164kjwr6kbxl">
      {visible && !dismissed && <motion.div role="status" initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-24 left-3 right-3 z-50 flex items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_12px_40px_rgba(7,31,43,0.25)] ring-1 ring-navy/10 sm:bottom-6 sm:left-6 sm:right-auto sm:max-w-sm" data-id="element-41" data-mp="1fviv386hszek">
          <img src={MOCKUP_URL} alt="" className="h-14 w-14 shrink-0 rounded-lg bg-brand-light object-contain p-1" data-id="element-42" data-mp="s5omj2t7hx04" />
          <div className="min-w-0" data-id="element-43" data-mp="28joglx5desfg">
            <p className="text-sm text-navy" data-id="element-44" data-mp="28imxr6i451n6">
              <strong data-id="element-45" data-mp="23lwi2ka8082a">{buyer.name}</strong> from <strong data-id="element-46" data-mp="23klfuowfb8da">{buyer.country}</strong>
            </p>
            <p className="text-[13px] text-navy/75" data-id="element-47" data-mp="2ap2zp6tk2k9l">just purchased the Pediatric Motor Planning Blueprint™</p>
            <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-brand" data-id="element-48" data-mp="2fmv3ay3kbutm">
              <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-49" data-mp="2km7qjjycj3wq" /> Verified · {minutes} min ago
            </p>
          </div>
          <button type="button" onClick={() => setDismissed(true)} aria-label="Close notification" className="absolute right-2 top-2 rounded-full p-1 text-navy/50 hover:text-navy" data-id="element-50" data-mp="2plbwm1pz4liu">
            <XIcon className="h-4 w-4" data-id="element-51" data-mp="21w9j962dheu5" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}